module.exports = __webpack_public_path__ + "static/img/xiaoyu.a9581bd7.png";